<div class="card">
    <form class="g-3" name="ExpensePoliciesForm" (ngSubmit)="Validate(ExpensePoliciesForm)"
        #ExpensePoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Expense Policy
                </div>
                <div class="card-body">
                    <div class="ms-5">
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="RuleName" class="form-label text-label-dark">Policy Name :</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                    id="RuleName" name="RuleName" [(ngModel)]="Expense.RuleName" #RuleName="ngModel"
                                    maxlength="100" required>
                                <div class="invalid-feedback">
                                    Please Enter Policy Name!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="Description" class="form-label text-label-dark">Description :</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. Discription"
                                    id="Description" name="Description" [(ngModel)]="Expense.Description"
                                    #Description="ngModel" maxlength="100">
                                <div class="invalid-feedback">
                                    Please Enter discription!
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row mb-3">
                            <div class="col-md-2">
                                <label class="form-label text-label-dark">Attachment :
                                </label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="Attachment"
                                            [(ngModel)]="Expense.Attachment" [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="Attachment"
                                            [(ngModel)]="Expense.Attachment" [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div> -->
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="TravelType" class="form-label text-label-dark">Travel Type:</label>
                            </div>
                            <div class="col-md-5">
                                @for (TravelType of common.TravelTypes; track TravelType.TravelType; let i = $index)
                                {
                                <label class="form-check-label link-dark px-1 text-label-light"
                                    *ngIf="(this.Expense.ESS_ExpenseRuleID == 0) || (this.Expense.ESS_ExpenseRuleID > 0 && common.ToLowerCase(Expense.TravelType) == common.ToLowerCase(TravelType.Value))"
                                    ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=TravelType.Value
                                        name='TravelType' [(ngModel)]="Expense.TravelType"
                                        [ngModelOptions]="{standalone: true}"
                                        (change)="TravelTypeChanges(TravelType.Value)"
                                        [disabled]="Expense.ESS_ExpenseRuleID > 0">
                                    {{TravelType.TravelType}}
                                </label>
                                }
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="LimitType" class="form-label text-label-dark">Limit Type:</label>
                            </div>
                            <div class="col-md-5">
                                @for (LimitType of common.LimitTypes; track LimitType.LimitType; let i = $index) {
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=LimitType.Value
                                        name='LimitType' [(ngModel)]="Expense.LimitType"
                                        [ngModelOptions]="{standalone: true}">
                                    {{LimitType.LimitType}}
                                </label>
                                }
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="DefaultRule" class="form-label text-label-dark">Mandate Report Submitted
                                    Before:</label>
                            </div>
                            <div class="col-md-2">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true
                                            name="IsReportToBeSubmittedBefore"
                                            [(ngModel)]="Expense.IsReportToBeSubmittedBefore"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false
                                            name="IsReportToBeSubmittedBefore"
                                            [(ngModel)]="Expense.IsReportToBeSubmittedBefore"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="input-group mb-3">
                                    <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                        [ngClass]="{'ng-invalid': common.parseFloat(Expense.ReportToBeSubmittedBefore) > 365}"
                                        placeholder="Ex. 01" id="ReportToBeSubmittedBefore"
                                        name="ReportToBeSubmittedBefore" [(ngModel)]="Expense.ReportToBeSubmittedBefore"
                                        #ReportToBeSubmittedBefore="ngModel"
                                        [disabled]="!Expense.IsReportToBeSubmittedBefore" required>
                                    <span class="input-group-text" id="basic-ReportToBeSubmittedBefore">day</span>
                                    <div class="invalid-feedback">
                                        Please enter maximum days 365!
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="DefaultRule" class="form-label text-label-dark">Employee Type:</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.Expense.ESS_ExpenseRuleID == 0) || (this.Expense.ESS_ExpenseRuleID > 0 && common.ToLowerCase(Expense.EmpType) == 'front')">
                                        <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                            [(ngModel)]="Expense.EmpType" [ngModelOptions]="{standalone: true}"
                                            (change)="GetApplicability()" [disabled]="Expense.ESS_ExpenseRuleID > 0"
                                            required>
                                        Front Office
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.Expense.ESS_ExpenseRuleID == 0) || (this.Expense.ESS_ExpenseRuleID > 0 && common.ToLowerCase(Expense.EmpType) == 'back')">
                                        <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                            [(ngModel)]="Expense.EmpType" [ngModelOptions]="{standalone: true}"
                                            (change)="GetApplicability()" [disabled]="Expense.ESS_ExpenseRuleID > 0"
                                            required>
                                        Back Office
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="DefaultRule" class="form-label text-label-dark">Default Rule :</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                            [(ngModel)]="Expense.DefaultRule" [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                            [(ngModel)]="Expense.DefaultRule" [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="card border-radius-0 m-1 p-0">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">Category</div>
                                    <div class="col-auto">
                                        <button type="button" class="btn btn btn-outline-primary btn-sm"
                                            (click)="addCategory()" [disabled]="isDisabled"><i class="bi bi-plus"
                                                *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Add Item':'Loading...'}}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <table datatable class="customeDatatable table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Category</th>
                                            <th scope="col">EffectiveDate</th>
                                            <th scope="col">Max Amount</th>
                                            <th scope="col">Max Count </th>
                                            <th scope="col">ReceiptRequired Limit</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">AtActual</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let Items of Expense.ESS_ExpenseCategoryLimitationsRule; let i = index">
                                            <th scope="row" style="align-content: center;">{{i + 1}}</th>
                                            <td>
                                                <div style="width:10rem">
                                                    <ng-select name="ESS_ExpenseCategoryMasterId{{i}}"
                                                        [items]="ExpenseCategorys"
                                                        [(ngModel)]="Items.ESS_ExpenseCategoryMasterId"
                                                        bindLabel="ExpenseCategoryName"
                                                        bindValue="ESS_ExpenseCategoryMasterId" placeholder="Category"
                                                        required>
                                                    </ng-select>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-group" style="width: 185px;">
                                                    <input class="form-control" placeholder="dd-mm-yyyy"
                                                        name="EffectiveDate{{i}}" [(ngModel)]="Items.EffectiveDateObj"
                                                        ngbDatepicker #EffectiveDate="ngbDatepicker" readonly
                                                        required />
                                                    <button class="btn btn-outline-secondary bi bi-calendar3"
                                                        (click)="EffectiveDate.toggle()" type="button"></button>
                                                </div>
                                            </td>
                                            <td>
                                                <input type="text" class="form-control" placeholder="Ex. 100"
                                                    name="MaxExpenseAmountLimit{{i}}"
                                                    [(ngModel)]="Items.MaxExpenseAmountLimit" maxlength="5"
                                                    pattern="^[0-9.]*$" [disabled]="Items.ExpenseCategoryAtActual"
                                                    (keypress)="common.NumberOnly($event,common.allowDot(Items.MaxExpenseAmountLimit))"
                                                    (keyup)="common.NumberOnly($event,common.allowDot(Items.MaxExpenseAmountLimit))"
                                                    #MaxExpenseAmountLimit="ngModel" required>
                                            </td>
                                            <td>
                                                <input type="text" class="form-control" placeholder="Ex. 100"
                                                    name="MaxExpenseCount{{i}}" [(ngModel)]="Items.MaxExpenseCount"
                                                    maxlength="5" pattern="^[0-9.]*$"
                                                    [disabled]="Items.ExpenseCategoryAtActual"
                                                    (keypress)="common.NumberOnly($event,common.allowDot(Items.MaxExpenseCount))"
                                                    (keyup)="common.NumberOnly($event,common.allowDot(Items.MaxExpenseCount))"
                                                    #MaxCount="ngModel" required>
                                            </td>
                                            <td>
                                                <div class="input-group mb-3">
                                                    <span class="input-group-text"><input class="form-check-input"
                                                            type="checkbox" id="IsReceiptRequired{{i}}"
                                                            name="IsReceiptRequired{{i}}"
                                                            [(ngModel)]="Items.IsReceiptRequired"></span>
                                                    <input type="text" class="form-control" placeholder="Ex. 100"
                                                        name="ReceiptRequiredLimit{{i}}"
                                                        [(ngModel)]="Items.ReceiptRequiredLimit" maxlength="5"
                                                        pattern="^[0-9.]*$" [disabled]="!Items.IsReceiptRequired"
                                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.ReceiptRequiredLimit))"
                                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.ReceiptRequiredLimit))"
                                                        #ReceiptRequiredLimit="ngModel" required>
                                                </div>
                                            </td>
                                            <td style="text-align: -webkit-center; align-content: center;"><input
                                                    class="form-check-input" type="checkbox"
                                                    id="MakeDescriptionMandatory{{i}}"
                                                    name="MakeDescriptionMandatory{{i}}"
                                                    [(ngModel)]="Items.MakeDescriptionMandatory"></td>
                                            <td style="text-align: -webkit-center; align-content: center;"><input
                                                    class="form-check-input" type="checkbox"
                                                    id="ExpenseCategoryAtActual{{i}}"
                                                    name="ExpenseCategoryAtActual{{i}}"
                                                    [(ngModel)]="Items.ExpenseCategoryAtActual"></td>
                                            <td style="align-content: center;text-align: center;"><i
                                                    class="bi bi-trash deleteIcon" (click)="deleteCategory(i)"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="card border-radius-0 m-1 p-0">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col">Mileage Limitation</div>
                                    <div class="col-auto">
                                        <button type="button" class="btn btn btn-outline-primary btn-sm"
                                            (click)="addMileageLimitation()" [disabled]="isDisabled"><i
                                                class="bi bi-plus" *ngIf="!isDisabled"></i>
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                            {{!isDisabled?'Add Item':'Loading...'}}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <table datatable class="customeDatatable table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Vehicle</th>
                                            <th scope="col">EffectiveDate</th>
                                            <th scope="col">Rate</th>
                                            <th scope="col">Limit</th>
                                            <th scope="col">ReceiptRequired Limit</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">AtActual</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let Items of Expense.ESS_ExpenseMilageLimitationsRule; let i = index">
                                            <th scope="row" style="align-content: center;">{{i + 1}}</th>
                                            <td>
                                                <div style="width:10rem">
                                                    <ng-select name="ESS_VehicleMasterId{{i}}" [items]="Vehicles"
                                                        [(ngModel)]="Items.ESS_VehicleMasterId" bindLabel="VehicleName"
                                                        bindValue="ESS_VehicleMasterId" placeholder="VehicleName"
                                                        required>
                                                    </ng-select>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-group">
                                                    <input class="form-control" placeholder="dd-mm-yyyy"
                                                        name="EffectiveDateM{{i}}" [(ngModel)]="Items.EffectiveDateObj"
                                                        ngbDatepicker #EffectiveDateM="ngbDatepicker" readonly
                                                        required />
                                                    <button class="btn btn-outline-secondary bi bi-calendar3"
                                                        (click)="EffectiveDateM.toggle()" type="button"></button>
                                                </div>
                                            </td>
                                            <td>
                                                <input type="text" class="form-control" placeholder="Ex. 100"
                                                    name="MileageRate{{i}}" [(ngModel)]="Items.MileageRate"
                                                    maxlength="5" pattern="^[0-9.]*$"
                                                    [disabled]="Items.ExpenseMilageAtActual"
                                                    (keypress)="common.NumberOnly($event,common.allowDot(Items.MileageRate))"
                                                    (keyup)="common.NumberOnly($event,common.allowDot(Items.MileageRate))"
                                                    #MileageRate="ngModel" required>
                                            </td>

                                            <td>
                                                <input type="text" class="form-control" placeholder="Ex. 100"
                                                    name="MileageLimit{{i}}" [(ngModel)]="Items.MileageLimit"
                                                    maxlength="5" pattern="^[0-9.]*$"
                                                    [disabled]="Items.ExpenseMilageAtActual"
                                                    (keypress)="common.NumberOnly($event,common.allowDot(Items.MileageLimit))"
                                                    (keyup)="common.NumberOnly($event,common.allowDot(Items.MileageLimit))"
                                                    #MileageLimit="ngModel" required>
                                            </td>
                                            <td>
                                                <div class="input-group mb-3">
                                                    <span class="input-group-text"><input class="form-check-input"
                                                            type="checkbox" id="MIsReceiptRequired{{i}}"
                                                            name="MIsReceiptRequired{{i}}"
                                                            [(ngModel)]="Items.IsReceiptRequired"></span>
                                                    <input type="text" class="form-control" placeholder="Ex. 100"
                                                        name="MReceiptRequiredLimit{{i}}"
                                                        [(ngModel)]="Items.ReceiptRequiredLimit" maxlength="5"
                                                        pattern="^[0-9.]*$" [disabled]="!Items.IsReceiptRequired"
                                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.ReceiptRequiredLimit))"
                                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.ReceiptRequiredLimit))"
                                                        #MReceiptRequiredLimit="ngModel" required>
                                                </div>
                                            </td>
                                            <td style="text-align: -webkit-center; align-content: center;"><input
                                                    class="form-check-input" type="checkbox"
                                                    id="MMakeDescriptionMandatory{{i}}"
                                                    name="MMakeDescriptionMandatory{{i}}"
                                                    [(ngModel)]="Items.MakeDescriptionMandatory"></td>
                                            <td style="text-align: -webkit-center; align-content: center;"><input
                                                    class="form-check-input" type="checkbox"
                                                    id="ExpenseMilageAtActual{{i}}" name="ExpenseMilageAtActual{{i}}"
                                                    [(ngModel)]="Items.ExpenseMilageAtActual"></td>
                                            <td style="align-content: center;text-align: center;"><i
                                                    class="bi bi-trash deleteIcon"
                                                    (click)="deletMileageLimitation(i)"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID' [(ngModel)]="Expense.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && Expense.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.Expense.ESS_ExpenseRuleID == 0) || (this.common.PageRight.IsEdit && this.Expense.ESS_ExpenseRuleID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>